export default __webpack_public_path__ + "images/0xb348b87b23d5977e2948e6f36ca07e1ec94d7328.png";